module.exports = __webpack_public_path__ + "img/cb-modal-close.dc4b8c92.svg";